<template>
  <div id="app">
    <div class="bg-image"/>
    <div class="bg-image-cover"/>
    <div class="app-content">
      <h1>data visualization / ui development</h1>
      <p>
        Hi, I'm Jefferson. I'm a web developer who specializes in data visualization.
        <br>I currently live in Boulder, CO. These are some of my personal projects.
      </p>
      <ProjectsView/>
    </div>
    <Footer/>
  </div>
</template>

<script>
import Footer from '@/components/Footer.vue';
import ProjectsView from '@/components/ProjectsView.vue';

export default {
  name: 'App',
  components: {
    Footer,
    ProjectsView,
  },
};
</script>

<style lang="scss">
@import url('https://fonts.googleapis.com/css?family=Roboto');
@import url('https://fonts.googleapis.com/css?family=Open+Sans');

body {
  background-color: #333;
  color: rgba(255, 255, 255, 0.8);
  font-family: 'Roboto', sans-serif;
  margin: 0;
  text-align: center;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

#app {
  position: relative;
}

.bg-image,
.bg-image-cover {
  left: 0;
  height: 100%;
  position: absolute;
  top: 0;
  width: 100%;
}

.bg-image {
  background-attachment: fixed;
  background-image: url('./assets/trees.jpg');
  background-size: cover;
}
.bg-image-cover { background-color: rgba(0, 0, 0, 0.6); }

.app-content {
  box-sizing: border-box;
  display: inline-block;
  max-width: 850px;
  min-height: 100vh;
  padding: 40px;
  position: relative;
  text-align: left;
  width: 100%;
}

h1 {
  font-family: 'Open Sans', sans-serif;
  margin-bottom: 25px;
}
</style>
